import { ReactNode, PropsWithChildren, MouseEvent } from "react"
import { BaseComponent, BaseProps, BaseState } from "../BaseComponent"

interface CeckboxProps extends BaseProps {
    checked: boolean
    className?: 'form-check-input',
    labelClassName?: 'form-check-label',
    callback?: Function | undefined
    getValueCallBack?: Function
}

interface CeckboxStatus extends BaseState {
}

const defaults : CeckboxProps = {
    id: undefined,
    checked: false,
    className : 'form-check-input',
    labelClassName: 'form-check-label',
    callback: undefined,
    getValueCallBack: undefined,
    children: undefined // evita dangerouslysetinnerhtml sul <input>
}

class Checkbox extends BaseComponent<PropsWithChildren<CeckboxProps>, CeckboxStatus> {

    constructor (props: any) {
        super(props)

        this.mergedProps = { ...defaults, ...props} as CeckboxProps

        this.onCLickHandler = this.onCLickHandler.bind(this)
    }

    render(): ReactNode {
        const errorTag = this.getError()

        const inputClassString = (this.props.className ?? '') + ' form-check-input'
            + (this.props.checked ? ' active' : '') 
        const labelClassString = (this.props.labelClassName ?? '') + ' form-check-label' 
            + (errorTag ? ' is-invalid' : '')

        const attributes = this.getPropertyDifferences (this.mergedProps ?? {}, defaults)

        return (
            this.props.id &&
            <>
                <input 
                    id={this.props.id}
                    type="checkbox" 
                    className={inputClassString}
                    autoComplete="off"
                    name={this.props.name}
                    checked={this.props.checked}
                    // riporto gli eventi a cui sono intressato
                    onChange={this.onChangeHandler}
                    onClick={this.onCLickHandler}
                    // stampo tutte le altre props
                    {...attributes} />
                <label 
                    className={labelClassString} 
                    htmlFor={`${this.mergedProps?.id}`}
                    onClick={this.onLabelClick}
                >
                    {errorTag !== undefined && errorTag}
                    {this.props.children}
                </label>
            </>
        )
    }

    onChangeHandler () {
        // volgio che funzioni al clik non al change
        return false
    }

    onLabelClick (e: MouseEvent<HTMLInputElement | HTMLLabelElement | HTMLAnchorElement>) {
        if ( (e.target as any)?.hasAttribute("href") === false) {
            e.stopPropagation()
            e.preventDefault()

            return false
        }
    }

    onCLickHandler (e: MouseEvent<HTMLInputElement | HTMLLabelElement>) {
        e.stopPropagation()
        e.preventDefault()

        if (this.props.disabled === true) {
            return
        }

        if (this.props.callback) {
            this.props.callback (
                !this.props.checked
            )
        } else if (this.props.getValueCallBack) {
            let a = e as MouseEvent<HTMLInputElement>

            this.props.getValueCallBack (
                a.currentTarget.value, !this.props.checked
            )
        }
    }
}

export default Checkbox